export default __webpack_public_path__ + "static/touchfree-kiosk-feedback-collector-voting-eea8c2bc5e378c7e6ee345e38cd9684f.jpg";